import { useLocation } from 'react-router'

import { useFcmDeviceRegistration } from './useFcmDeviceRegistration'
// import { useFreshpaint } from './useFreshpaint'
import { useNativeBackHandler } from './useNativeBackHandler'
import { useNativeEventBridge } from './useNativeEventBridge'
import { usePopup } from './usePopup'
import { usePushNotificationNavigation } from './usePushNotificationNavigation'
import { useServerMaintenance } from './useServerMaintenance'

const useApp = () => {
  const location = useLocation()

  useNativeEventBridge()
  useNativeBackHandler()
  usePushNotificationNavigation()
  useFcmDeviceRegistration()

  // useFreshpaint()

  useServerMaintenance()

  usePopup()

  return { location }
}

export default useApp
